import serviceActionPrioritiesComponent from './service-action-priorities.component';

let serviceActionPrioritiesModule = angular.module('serviceActionPriorities', [])
    .component('serviceActionPriorities', serviceActionPrioritiesComponent)
    .name;

export default serviceActionPrioritiesModule;



// WEBPACK FOOTER //
// ./client/app/components/service_settings/service-action-priorities/index.js